import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FiEyeOff, FiEye } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";
import cmtiLogo from "../../images/LandingPage/cmti-logo.png";
import Ficon from "../../images/LandingPage/icon.png";
import bgVideo from "../../images/Login/foundry40.mp4";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [showSigninPassword, setShowSigninPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    role: "SUPERVISOR",
    password: "",
    repeatPassword: "",
  });
  const [errors, setErrors] = useState({});

  const toggleForm = () => {
    setIsSignUp(!isSignUp);
    setFormData({
      fullName: "",
      email: "",
      phoneNumber: "",
      role: "SUPERVISOR",
      password: "",
      repeatPassword: "",
    });
    setErrors({});
  };

  // password show and hide

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRepeatPasswordVisibility = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };
  const toggleSignInVisible = () => {
    setShowSigninPassword(!showSigninPassword);
  };

  //

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (isSignUp && !formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (isSignUp && !formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone Number is required";
    } else if (isSignUp && !/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone Number must be 10 digits";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{5,10}/.test(
        formData.password
      )
    ) {
      newErrors.password =
        "Password must contain 5-10 characters with at least one uppercase letter, one lowercase letter, one number, and one special character";
    }

    if (isSignUp && formData.password !== formData.repeatPassword) {
      newErrors.repeatPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error(
        "Form validation failed. Please correct the errors and try again."
      );
      return;
    }

    try {
      const response = await axios.post(
        "https://cmti-edge.online/foundry/php/auth.php",
        {
          action: isSignUp ? "signup" : "signin",
          ...formData,
        }
      );

      if (response.data.message) {
        toast.success(response.data.message);
        if (!isSignUp) {
          localStorage.setItem("user", JSON.stringify(response.data.user));
          navigate("/home");
        } else {
          setIsSignUp(false);
          setFormData({
            ...formData,
            fullName: "",
            phoneNumber: "",
            repeatPassword: "",
          });
          toast.info("Please sign in with your new account.");
        }
      } else if (response.data.error) {
        toast.error(response.data.error);
      } else {
        toast.error("Unexpected response from server");
      }
    } catch (error) {
      console.error("Error details:", error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        toast.error(
          `Server error: ${error.response.data.error || "Unknown error"}`
        );
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        toast.error(
          "No response from server. Please check your internet connection."
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", error.message);
        toast.error(`Error: ${error.message}`);
      }
    }
  };

  return (
    <div className="">
      <header className="header bg-white flex justify-center items-center  shadow-md w-full ">
        <nav className="header__nav container mx-auto p-5  flex justify-between items-center">
          <a href="/" className="header__logo flex items-center">
            <img src={Ficon} alt="Smart Foundry 4.0" className="h-20 w-72 " />
          </a>
          <div className="header__pattern flex items-center justify-center flex-1">
            <svg className="w-full h-12 md:h-16 lg:h-20">
              <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                fill="url(#polka-dots)"
              />
              <text
                className="text-pattern  font-bold"
                x="50%"
                y="50%"
                textAnchor="middle"
                alignmentBaseline="middle"
              >
                Integrated Smart Foundry
              </text>
            </svg>
          </div>
          <a href="/" className="header__cmti-logo flex items-center">
            <img src={cmtiLogo} alt="CMTI" className="h-24 p-1" />
          </a>
        </nav>
      </header>
      <div className="relative min-h-screen">
        <video
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src={bgVideo} type="video/mp4" />
        </video>
        <div className="absolute top-0 left-0 w-full h-full bg-black/40 z-10 flex flex-col items-center justify-center px-4">
          <ToastContainer />

          <div className="form__signup bg-slate-50 rounded-3xl shadow-lg w-full max-w-md sm:max-w-lg z-20">
            {isSignUp ? (
              <div>
                <h2 className="text-3xl font-bold mb-6 mt-6 text-center text-gray-800">
                  Sign Up
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.fullName ? "border-red-500" : ""
                      }`}
                      placeholder="John Doe"
                      required
                    />
                    {errors.fullName && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.fullName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.email ? "border-red-500" : ""
                      }`}
                      placeholder="john@example.com"
                      required
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.phoneNumber ? "border-red-500" : ""
                      }`}
                      placeholder="+91-12345 78907"
                      required
                    />
                    {errors.phoneNumber && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Role
                    </label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="w-80 max-w-xs h-12 px-4 py-2 border border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition ease-in-out duration-300 sm:max-w-md md:max-w-lg lg:max-w-xl"
                    >
                      <option value="MANAGER">Manager</option>
                      <option value="SUPERVISOR">Supervisor</option>
                      <option value="OPERATOR">Operator</option>
                    </select>
                  </div>

                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.password ? "border-red-500" : ""
                      }`}
                      placeholder="********"
                      required
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center px-2">
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="focus:outline-none"
                      >
                        {showPassword ? <FiEye /> : <FiEyeOff />}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.password}
                      </p>
                    )}
                  </div>

                  <div className="relative mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Repeat Password
                    </label>
                    <input
                      type={showRepeatPassword ? "text" : "password"}
                      name="repeatPassword"
                      value={formData.repeatPassword}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.repeatPassword ? "border-red-500" : ""
                      }`}
                      placeholder="********"
                      required
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center px-2">
                      <button
                        type="button"
                        onClick={toggleRepeatPasswordVisibility}
                        className="focus:outline-none"
                      >
                        {showRepeatPassword ? <FiEye /> : <FiEyeOff />}
                      </button>
                    </div>
                    {errors.repeatPassword && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.repeatPassword}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Sign Up
                  </button>
                </form>
                <p className="mt-6 mb-4 text-center text-sm text-gray-600">
                  Already have an account?{" "}
                  <span
                    onClick={toggleForm}
                    className="text-blue-500 cursor-pointer hover:underline"
                  >
                    Sign In
                  </span>
                </p>
              </div>
            ) : (
              <div>
                <h2 className="text-3xl font-bold mb-6 mt-6 text-center text-gray-800">
                  Sign In
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.email ? "border-red-500" : ""
                      }`}
                      placeholder="john@example.com"
                      required
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Role
                    </label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className={`w-80 h-10 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        errors.role ? "border-red-500" : ""
                      }`}
                    >
                      <option value="MANAGER">Manager</option>
                      <option value="SUPERVISOR">Supervisor</option>
                      <option value="OPERATOR">Operator</option>
                    </select>
                    {errors.role && (
                      <p className="text-red-500 text-xs mt-1">{errors.role}</p>
                    )}
                  </div>
                  <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Password
      </label>
      <input
        type={showSigninPassword ? "text" : "password"}
        name="password"
        value={formData.password}
        onChange={handleChange}
        className={`w-80 h-8 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          errors.password ? "border-red-500" : ""
        }`}
        placeholder="********"
        required
      />
      <div className="absolute inset-y-0 right-0 flex items-center px-2">
        <button
          type="button"
          onClick={toggleSignInVisible}
          className="focus:outline-none"
        >
          {showSigninPassword ? <FiEye /> : <FiEyeOff /> }
        </button>
      </div>
      {errors.password && (
        <p className="text-red-500 text-xs mt-1">
          {errors.password}
        </p>
      )}
    </div>
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    Sign In
                  </button>
                </form>
                <p className="mt-6 mb-4 text-center text-sm text-gray-600">
                  Don't have an account?{" "}
                  <span
                    onClick={toggleForm}
                    className="text-blue-500 cursor-pointer hover:underline"
                  >
                    Sign Up
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
